// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import Permissions from '../core/permissions';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'networks';

class NetworkScrollable extends Component {
    getColumnConfig() {
        return [
            {
                dataKey: 'name',
                link: '/vfb',
                linkKey: 'networkId',
                title: 'Name',
                type: 'link',
                width: '100%',
            },
        ];
    }

    getTablewithsortProps() {
        return {
            ...this.props,
            ...{
                activeRowKeys: ['networkId'],
                activeRowValueKey: 'routerParams.networkId',
                columnConfig: this.getColumnConfig(),
                servicesDataKey,
            },
        };
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxPages: 9,
            query,
            totalPages,
        };
    }

    renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Name" name="name" title="Use wildcard (*) for partial name match" />
            <FormButtons />
        </ServicesSearchForm>
    );

    render() {
        const {searchData} = this.props;

        return (
            <Permissions
                accessRequirement="update"
                elementService="vfb"
                notAuthorizedMessage={true}
                requiresServiceAccess={true}
            >
                <div className="networks">
                    <ServicesExportPanelAction searchData={searchData} />
                    <ServicesSearchPanelAction contentRenderer={this.renderForm} showPanel={true} />
                    <SearchPagination {...this.getPaginationProps()} />
                    <SearchTableWithSort {...this.getTablewithsortProps()} />
                </div>
            </Permissions>
        );
    }
}

NetworkScrollable.propTypes = {
    query: PropTypes.object,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withSearch(NetworkScrollable, servicesDataKey);
